import { REPORT_TYPES } from './constants'

export const groupBy = (items, key) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {},
  )

export const getOrderDescriptionsById = (data, id, infoKey, nameKey) => {
  if (!data) return []

  const orderDetailsById = data
    .find((item) => item.id === id)
    [infoKey].map((item) => item[nameKey])
    .filter((item, index, self) => self.indexOf(item) === index)

  return orderDetailsById
}

export const countVolumeReports = (
  data,
  id,
  infoKey,
  nameKey,
  idKey,
  volumeKey,
) => {
  if (!data) return []
  const orderDetailsById = data
    .find((item) => item.id === id)
    [infoKey].reduce((prev, cur) => {
      if (cur[idKey] === REPORT_TYPES.SCREENING) {
        return { ...prev, [cur[nameKey]]: cur[volumeKey] }
      } else {
        return { ...prev, [cur[nameKey]]: (prev[cur[nameKey]] || 0) + 1 }
      }
    }, {})

  return orderDetailsById
}
